<template></template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import FormatNumber from '../shared/formatNumber.js';
export default {};
Vue.use(VueI18n);
Vue.use(FormatNumber);
const i18n = new VueI18n({
	locale: 'locale',
	fallbackLocale: 'locale',
	messages: {
		locale: window.langMap,
	},
});

window.addEventListener('DOMContentLoaded', function () {
	// initialize components on page load
	if (document.querySelector('[data-lichen-vue]')) {
		var els = document.querySelectorAll('[data-lichen-vue]');
		Array.prototype.forEach.call(els, function (el) {
			new Vue({ el: el, i18n });
		});
	}

	// species stat
	var loading = document.getElementById('totalsBusyImg');
	if (loading != null && loading) {
		loading.src = window.busyImgSrc;
		axios
			.get('listing/totalInRegion', {
				params: {
					rtype2: window.regionType,
					r2: window.r,
				},
			})
			.then(function (res) {
				var count = document.getElementById('listTotalDisp');
				count.textContent = parseInt(res.data).toLocaleString(locale, 'en-US');
				loading.style = 'display:none;';
			});
	}

	// initialize modals
	if (document.querySelector('[data-lichen-dialog]')) {
		const els = document.querySelectorAll('[data-lichen-dialog]');
		Array.prototype.forEach.call(els, function (el) {
			const id = el.getAttribute('data-lichen-dialog');
			new Vue({
				el: el,
				i18n,
				data() {
					return {
						open: false,
						opener: null,
						id: id,
					};
				},
				mounted() {
					const togglers = document.querySelectorAll('[aria-controls="' + this.id + '"]');
					Array.prototype.forEach.call(togglers, (toggler) => {
						toggler.addEventListener('click', this.show);
					});
					// listen for event from CloLightbox
					if (this.id === 'exotics-modal') {
						document.addEventListener('lichen:exotics-dialog', (e) => {
							this.open = true;
							this.opener = e.detail.opener;
						});
					}
				},
				methods: {
					show(e) {
						this.open = true;
						this.opener = e.target;
					},
					close() {
						this.open = false;
						// important: put focus back on element that triggered the dialog
						if (this.opener) {
							this.opener.focus();
						}
					},
				},
			});
		});
	}

	// lazy load components with data-lichen-vue-lazy attribute
	var lichenComponentObserver = new IntersectionObserver(function (changes) {
		changes.forEach(function (change) {
			var el = change.target;
			// check the lazy attribute and if it's intersecting the viewport
			if (el.hasAttribute('data-lichen-vue-lazy') && change.intersectionRatio > 0) {
				// wait for the browser to idle
				requestAnimationFrame(function () {
					el.removeAttribute('data-lichen-vue-lazy');
					el.setAttribute('data-lichen-vue', true);
					if (el.hasAttribute('data-lichen-url')) {
						var url = el.getAttribute('data-lichen-url');
						axios.get(url).then(function (res) {
							if (url.indexOf('product/media/rare') !== -1) {
								// must be the rarity feed
								//res.data = [{"assetId":"275557551","userDisplayName":"Simon Colenutt","commonName":"Lesser Yellowlegs","sciName":"Tringa flavipes","obsDt":"26 Oct 2020","obsTime":"10:34","subId":"S75427488","locId":"L1290811","speciesCode":"lesyel","confirmed":false,"profileHandle":"NjM3OTgw","userProfileUrl":"https://ebird.org/profile/NjM3OTgw","location":"Isles of Scilly--Tresco, Cornwall, England, GB"},{"assetId":"275557521","userDisplayName":"Simon Colenutt","commonName":"Lesser Yellowlegs","sciName":"Tringa flavipes","obsDt":"26 Oct 2020","obsTime":"10:34","subId":"S75427488","locId":"L1290811","speciesCode":"lesyel","confirmed":false,"profileHandle":"NjM3OTgw","userProfileUrl":"https://ebird.org/profile/NjM3OTgw","location":"Isles of Scilly--Tresco, Cornwall, England, GB"},{"assetId":"275557421","userDisplayName":"David A. Hofmann","commonName":"Lapland Longspur","sciName":"Calcarius lapponicus","obsDt":"29 Oct 2020","obsTime":"08:35","subId":"S75568053","locId":"L606176","speciesCode":"laplon","confirmed":false,"profileHandle":"MzA3NDg0","userProfileUrl":"https://ebird.org/profile/MzA3NDg0","location":"Bodega Head - offshore species and the bluff ONLY, Sonoma, California, US"},{"assetId":"275557381","userDisplayName":"David A. Hofmann","commonName":"Lapland Longspur","sciName":"Calcarius lapponicus","obsDt":"29 Oct 2020","obsTime":"08:35","subId":"S75568053","locId":"L606176","speciesCode":"laplon","confirmed":false,"profileHandle":"MzA3NDg0","userProfileUrl":"https://ebird.org/profile/MzA3NDg0","location":"Bodega Head - offshore species and the bluff ONLY, Sonoma, California, US"},{"assetId":"275557361","userDisplayName":"David A. Hofmann","commonName":"Lapland Longspur","sciName":"Calcarius lapponicus","obsDt":"29 Oct 2020","obsTime":"08:35","subId":"S75568053","locId":"L606176","speciesCode":"laplon","confirmed":false,"profileHandle":"MzA3NDg0","userProfileUrl":"https://ebird.org/profile/MzA3NDg0","location":"Bodega Head - offshore species and the bluff ONLY, Sonoma, California, US"},{"assetId":"275556771","userDisplayName":"Brian Bauld","commonName":"Sulphur-bellied Flycatcher","sciName":"Myiodynastes luteiventris","obsDt":"23 Oct 2020","obsTime":"05:00","subId":"S75438514","locId":"L12598087","speciesCode":"subfly","confirmed":false,"profileHandle":"MzE0MTM1","userProfileUrl":"https://ebird.org/profile/MzE0MTM1","location":"1390 New Brunswick 114, Lower Coverdale, New Brunswick, CA (46.034, -64.719), Albert, New Brunswick, CA"},{"assetId":"275556821","userDisplayName":"Brian Bauld","commonName":"Sulphur-bellied Flycatcher","sciName":"Myiodynastes luteiventris","obsDt":"23 Oct 2020","obsTime":"05:00","subId":"S75438514","locId":"L12598087","speciesCode":"subfly","confirmed":false,"profileHandle":"MzE0MTM1","userProfileUrl":"https://ebird.org/profile/MzE0MTM1","location":"1390 New Brunswick 114, Lower Coverdale, New Brunswick, CA (46.034, -64.719), Albert, New Brunswick, CA"},{"assetId":"275556811","userDisplayName":"Brian Bauld","commonName":"Sulphur-bellied Flycatcher","sciName":"Myiodynastes luteiventris","obsDt":"23 Oct 2020","obsTime":"05:00","subId":"S75438514","locId":"L12598087","speciesCode":"subfly","confirmed":false,"profileHandle":"MzE0MTM1","userProfileUrl":"https://ebird.org/profile/MzE0MTM1","location":"1390 New Brunswick 114, Lower Coverdale, New Brunswick, CA (46.034, -64.719), Albert, New Brunswick, CA"},{"assetId":"275556791","userDisplayName":"Brian Bauld","commonName":"Sulphur-bellied Flycatcher","sciName":"Myiodynastes luteiventris","obsDt":"23 Oct 2020","obsTime":"05:00","subId":"S75438514","locId":"L12598087","speciesCode":"subfly","confirmed":false,"profileHandle":"MzE0MTM1","userProfileUrl":"https://ebird.org/profile/MzE0MTM1","location":"1390 New Brunswick 114, Lower Coverdale, New Brunswick, CA (46.034, -64.719), Albert, New Brunswick, CA"},{"assetId":"275556501","userDisplayName":"Bernard Morris","commonName":"Mexican Duck","sciName":"Anas diazi","obsDt":"29 Oct 2020","obsTime":"09:30","subId":"S75568285","locId":"L3347228","speciesCode":"mexduc","confirmed":false,"profileHandle":"NTM0MTE5","userProfileUrl":"https://ebird.org/profile/NTM0MTE5","location":"Corrales Bosque -- Dixon Rd access, Sandoval, New Mexico, US"},{"assetId":"275556431","userDisplayName":"Colin Dobson","commonName":"White-winged Scoter","sciName":"Melanitta deglandi","obsDt":"29 Oct 2020","obsTime":"14:59","subId":"S75568150","locId":"L12617911","speciesCode":"whwsco2","confirmed":false,"profileHandle":"MjAxMzg3","userProfileUrl":"https://ebird.org/profile/MjAxMzg3","location":"61944, Paris US-IL (39.6315,-87.6696), Edgar, Illinois, US"},{"assetId":"275556371","userDisplayName":"Colin Dobson","commonName":"White-winged Scoter","sciName":"Melanitta deglandi","obsDt":"29 Oct 2020","obsTime":"14:59","subId":"S75568150","locId":"L12617911","speciesCode":"whwsco2","confirmed":false,"profileHandle":"MjAxMzg3","userProfileUrl":"https://ebird.org/profile/MjAxMzg3","location":"61944, Paris US-IL (39.6315,-87.6696), Edgar, Illinois, US"},{"assetId":"275556381","userDisplayName":"Colin Dobson","commonName":"White-winged Scoter","sciName":"Melanitta deglandi","obsDt":"29 Oct 2020","obsTime":"14:59","subId":"S75568150","locId":"L12617911","speciesCode":"whwsco2","confirmed":false,"profileHandle":"MjAxMzg3","userProfileUrl":"https://ebird.org/profile/MjAxMzg3","location":"61944, Paris US-IL (39.6315,-87.6696), Edgar, Illinois, US"},{"assetId":"275556351","userDisplayName":"Colin Dobson","commonName":"White-winged Scoter","sciName":"Melanitta deglandi","obsDt":"29 Oct 2020","obsTime":"14:59","subId":"S75568150","locId":"L12617911","speciesCode":"whwsco2","confirmed":false,"profileHandle":"MjAxMzg3","userProfileUrl":"https://ebird.org/profile/MjAxMzg3","location":"61944, Paris US-IL (39.6315,-87.6696), Edgar, Illinois, US"},{"assetId":"275556261","userDisplayName":"Mark A. Brogie","commonName":"Surf Scoter","sciName":"Melanitta perspicillata","obsDt":"29 Oct 2020","obsTime":"08:20","subId":"S75568236","locId":"L8105800","speciesCode":"sursco","confirmed":false,"profileHandle":"MTQxNjQ5","userProfileUrl":"https://ebird.org/profile/MTQxNjQ5","location":"Lewis and Clark Lake. Knox County, Knox, Nebraska, US"},{"assetId":"275556211","userDisplayName":"Mark A. Brogie","commonName":"Black Scoter","sciName":"Melanitta americana","obsDt":"29 Oct 2020","obsTime":"08:20","subId":"S75568236","locId":"L8105800","speciesCode":"blksco2","confirmed":false,"profileHandle":"MTQxNjQ5","userProfileUrl":"https://ebird.org/profile/MTQxNjQ5","location":"Lewis and Clark Lake. Knox County, Knox, Nebraska, US"},{"assetId":"275555811","userDisplayName":"stevan brad","commonName":"Golden-crowned Sparrow","sciName":"Zonotrichia atricapilla","obsDt":"29 Oct 2020","obsTime":"08:46","subId":"S75562252","locId":"L9843892","speciesCode":"gocspa","confirmed":false,"location":"Snowcreek Meadow Preserve, Mono, California, US"}];
								res.data = res.data.map((item) => {
									item.mediaType = 'Photo';
									item.unconfirmed = !item.confirmed;
									item.valid = !item.confirmed ? 'false' : true;
									item.eBirdChecklistId = item.subId;
									item.source = 'ebird';
									item.licenseType = 'anylabuse_v1';
									// Needed for ratings template to render. These values will get refreshed
									item.rating = '0';
									item.ratingCount = '0';
									//item.previewUrl = 'https://cdn.download.ams.birds.cornell.edu/api/v2/asset/' + item.assetId + '/';
									item.obsDttm = item.obsDt;
									item.eBirdChecklistUrl = 'https://ebird.org/checklist/' + item.eBirdChecklistId;
									item.specimenUrl = 'https://macaulaylibrary.org/asset/' + item.assetId;
									//if (showSpecimenLink) {
									//item.showSpecimenLink = 'true';
									//}
									item.subjectData = [
										{
											subjectTags: {},
										},
									];
									return item;
								});
							}
							new Vue({
								el: el,
								data() {
									return { response: res.data };
								},
								mounted() {
									//console.log('mounted', this.response);
								},
								i18n,
							});
						});
					} /*else if (el.hasAttribute('data-lichen-checklist-report-media')) {
						const speciesCode = el.getAttribute('data-lichen-checklist-report-media');
						new Vue({
								el: el,
								data() {
									return { list: window.obsMediaData[speciesCode] };
								},
								i18n,
								methods: {
									// open lightbox
									openLightbox(assetId) {
										document.dispatchEvent(new CustomEvent('checklist-report-lightbox-open', { detail: assetId }));
									},
								},
							});
					} */ else {
						new Vue({ el: el, i18n });
					}
				});
			}
		});
	});
	Array.prototype.map.call(document.querySelectorAll('[data-lichen-vue-lazy]'), function (el) {
		lichenComponentObserver.observe(el);
	});

});
</script>

<style lang="scss">
.u-rowFold {
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	column-gap: $space-md;
	row-gap: $space-xs;
	&--center {
		align-items: center;
	}
	&--spread {
		justify-content: space-between;
	}
	&--reverse {
		flex-wrap: wrap-reverse;
	}
	.u-rowFold-start,
	.u-rowFold-end {
		flex-grow: 1;
		display: flex;
		align-items: baseline;
		column-gap: $space-sm;
		row-gap: $space-xs;
	}
	.u-rowFold-end {
		justify-content: flex-end;
	}
}

.u-colorReverse {
	h3.Dropdown-heading {
		@include link($color-link-reverse, false, true);
	}
	.Dropdown-panel a {
		@include link;
	}
}

// Subtle links are not blue but turn blue and underlined on hover
a.u-linkSubtle,
.u-linkSubtle a {
	@include interactiveColor(color, $color-black, $color-link-hover);
	text-underline-offset: $space-rel-xs;
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-thickness: 0.0625rem;
	@include interactiveColor(text-decoration-color, transparent, $color-link-hover);
}

// Partner Logos
.PartnerLogos {
	position: relative;
	max-width: 100%;
	.LogosGrid {
		min-width: 0;
		max-width: 100%;
		border-radius: $radius-sm;
		// .LogosGrid-item img,
		// .LogosGrid-item svg {
		// 	max-width: min(16rem, 100%);
		// }
	}
}

.PartnerLogos-identity {
	img {
		max-width: 100%;
	}
}

.PartnerLogos-all {
	display: grid;
	align-items: flex-start;
	min-width: 0;
	max-width: 100%;
	grid-gap: $space-md;
	@include breakpoint(large) {
		grid-template-columns: 50% 1fr;
	}
	@include breakpoint(xlarge) {
		grid-template-columns: 33% 1fr;
	}
	&-desc {
		display: flex;
		flex-direction: column;
		gap: $space-xs;
		p {
			// font-family: $body-font-family;
			@include text(3);
			margin-block-end: 0;
		}
		a {
			// font-family: $body-font-family;
			@include text(3);
		}
		@include breakpoint(medium) {
			gap: $space-sm;
			p,
			a {
				@include text(4, loose);
			}
		}
		.LogosGrid {
			background: none;
			padding: none;
		}
	}
	&-logos {
		background: $brand-color-sand-2;
		border-radius: $space-sm;
		overflow: hidden;
		&--grouped {
			display: flex;
			flex-wrap: wrap;
			.LogosGrid {
				width: auto;
				flex: 1 1 50%;
			}
		}
	}
	.PartnerLogos-identity img {
		height: 2.75rem;
	}
	.LogosGrid {
		border-radius: $space-sm;
		padding: $space-sm;
		@include breakpoint(medium) {
			padding: $space-md;
		}
		&--overflow {
			.LogosGrid-group {
				overflow-x: auto;
				mask-image: linear-gradient(90deg, #000 95%, rgba(0, 0, 0, 0.025));
				padding: $space-xs;
				display: flex;
				min-width: 0;
				.LogosGrid-item {
					flex: 1 0 8rem;
					img,
					svg {
						max-height: 4rem;
						@include breakpoint(medium) {
							max-height: 6rem;
						}
					}
				}
			}
		}
	}
}

.PartnerLogos-primary {
	display: grid;
	grid-gap: $space-md;
	grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
	@include stack-md;
	.PartnerLogos-identity img {
		height: 3.25rem;
	}
	&-desc {
		align-self: center;
		display: flex;
		flex-direction: column;
		gap: $space-sm;
		p {
			// font-family: $body-font-family;
			@include text(4, loose);
			margin-block-end: 0;
		}
	}
}

// Resource links
.ResourceLinks {
	overflow: hidden;
	ul.ResourceLinks-list {
		list-style: none;
		margin: 0;
		display: grid;
		min-width: 0;
		max-width: 100%;
		grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
		border-radius: $space-sm;
		column-gap: $space-md;
		row-gap: $space-sm;
		@include breakpoint(large) {
			row-gap: $space-md;
		}
		li {
			padding-inline-start: $space-sm;
			border-inline-start: 1px solid subdueColor($color-black);
			@include text(2);
			line-height: 1.25;
			@include breakpoint(large) {
				@include text(3);
				line-height: 1.25;
			}
		}
	}
	&--sidebar {
		padding-inline-start: $space-md;
		border-inline-start: 1px solid subdueColor($color-black);
		ul.ResourceLinks-list {
			margin: 0;
			list-style: none;
			display: flex;
			flex-direction: column;
			gap: $space-sm;
			li {
				padding-inline-start: 0;
				border-inline-start: none;
				@include text(3, loose);
			}
		}
	}
	&--widget {
		background: $brand-color-sky-blue-2;
		@include inset-md;
		border-radius: $space-sm;
		ul.ResourceLinks-list {
			grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
			// display: flex;
			// flex-wrap: wrap;
			// min-width: 0;
			// overflow-x: auto;
			// mask-image: linear-gradient(90deg, #000 90%, rgba(0, 0, 0, 0.025));
			// padding-inline-end: $space-xl;
			li {
				flex: 0 0 12rem;
			}
		}
	}
}

.PoweredBy {
	background-color: $brand-color-sand;
	@include inset-md;
	border-radius: $space-sm;
	display: flex;
	flex-wrap: wrap;
	column-gap: $space-md;
	row-gap: $space-xs;
	align-items: center;
	justify-content: center;
	@include text(2);
	text-transform: uppercase;
	color: $color-text-muted;
	img {
		height: 2rem;
	}
}

// News group
.NewsGroup {
	list-style: none;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: $space-lg;
	max-width: 100%;
	&--hierarchical {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: auto;
		li {
			grid-column: span 2;
		}
		@include breakpoint(medium) {
			li:not(:first-child) {
				grid-column: span 1;
			}
		}
	}
}

// News Feed
.NewsFeed {
	container: post-container / inline-size;
	ul.NewsFeed-list {
		list-style: none;
		margin: 0;
		display: flex;
		flex-direction: column;
		gap: $space-md;
		max-width: 100%;
	}
	@container (min-width: 32rem) {
		ul.NewsFeed-list {
			gap: $space-lg;
		}
	}
}

// Logos Grid modifier
.LogosGrid.LogosGrid--sm {
	.LogosGrid-item {
		@include inset-sm;
		min-height: 4rem;
		img,
		svg {
			max-width: 100%;
			max-height: 5rem;
		}
	}
}

.adAside {
	display: flex;
	flex-wrap: wrap;
	column-gap: $space-lg;
	row-gap: $space-sm;
	&-main {
		flex: 2 0 75%;
	}
	&-aside {
		flex: 1 1 6rem;
	}
}

// Wordpress content card
.WordpressContentCard {
	container: wordpressContentCard-container / inline-size;
	display: grid;
	column-gap: $space-md;
	row-gap: $space-sm;
	grid-template-columns: min(25%, 16rem) 1fr;
	.WordpressContentCard-img {
		grid-column: 1/2;
	}
	.WordpressContentCard-content {
		grid-column: 2/3;
		padding-block-start: $space-xs;
		border-top: solid 1px subdueColor($color-black);
		display: flex;
		flex-direction: column;
		gap: $space-xs;
		.Heading {
			margin-block-end: 0;
		}
		.WordpressContentCard-content-meta {
			@include text(2);
			color: $color-text-muted;
			display: flex;
			flex-wrap: wrap;
			align-items: baseline;
			row-gap: $space-xs;
			span:not(:last-child)::after {
				content: '|';
				padding-inline: $space-sm;
				color: subdueColor($color-black);
			}
		}
		p {
			@include text(2);
			@include visuallyHidden;
			margin-block-end: 0;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow-y: hidden;
		}
		@container (min-width: 30rem) {
			.WordpressContentCard-content-meta {
				@include text(3);
			}
			p {
				@include overrideVisuallyHidden;
				display: -webkit-box;
				@include text(2);
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow-y: hidden;
			}
		}
		&--inline {
			flex-direction: row;
			flex-wrap: wrap;
			align-items: baseline;
			column-gap: $space-md;
		}
	}
	&--lg {
		@container (min-width: 30rem) {
			.WordpressContentCard-content {
				padding-block-start: $space-md;
				.Heading {
					@include h3;
					margin-block-end: 0;
				}
				.WordpressContentCard-content-meta {
					@include text(3);
				}
				p {
					@include text(3);
					-webkit-line-clamp: 3;
				}
			}
		}
	}
	&--person {
		grid-template-columns: min(20%, 10rem) 1fr;
		.WordpressContentCard-content {
			.WordpressContentCard-content-meta {
				flex-direction: column;
				gap: 0;
				span:not(:last-child)::after {
					content: none;
				}
			}
		}
	}
	&--noImg .WordpressContentCard-content {
		grid-column: 1 / 3;
	}
	&--page {
		.WordpressContentCard-content {
			p {
				@include overrideVisuallyHidden;
			}
		}
	}
}

// Language pills on wordpress posts/pages
.LanguagePills {
	ul {
		margin: 0;
		list-style: none;
		display: inline-flex;
		flex-wrap: wrap;
		align-items: center;
		column-gap: $space-sm;
		li {
			line-height: 1;
		}
	}
	a {
		@include text(2);
		padding: 0.25em 0.5em;
		border: $space-xxs solid $color-link;
		@include interactiveColor(background, $brand-color-ocean-blue-2, $brand-color-ocean-blue-3);
		@include interactiveColor(border-color, $brand-color-ocean-blue-2, hoverColor($color-link));
		border-radius: $space-md;
		text-transform: uppercase;
		span {
			text-transform: none;
		}
		&[aria-current='true'] {
			@include interactiveColor(color, $color-link-special, $color-link-special);
			@include interactiveColor(background-color, $brand-color-forest-green-2, $brand-color-forest-green-2);
			@include interactiveColor(border-color, $color-link-special, $color-link-special);
		}
	}
	// Override style in Blurb-meta that's adding a pipe between each language pill
	li:not(:first-child)::before {
		content: none;
		margin: 0;
	}
	&--sm {
		ul {
			column-gap: $space-xs;
		}
		a {
			@include text(1);
			padding: 0.125em 0.36em;
		}
	}
	&--reverse {
		a {
			@include interactiveColor(color, $color-link-reverse, $color-link-hover-reverse);
			border: $space-xxs solid $color-link-reverse;
			@include interactiveColor(background, $brand-color-ocean-blue-dark-2, $brand-color-ocean-blue-dark-3);
			@include interactiveColor(border-color, $brand-color-ocean-blue-dark-2, hoverColor($color-link-reverse, true));
			&[aria-current='true'] {
				@include interactiveColor(color, $color-link-special-reverse, $color-link-special-reverse);
				@include interactiveColor(background-color, $brand-color-forest-green-dark-2, $brand-color-forest-green-dark-2);
				@include interactiveColor(border-color, $color-link-special-reverse, $color-link-special-reverse);
			}
		}
	}
}

// Region context stats
#stats.StatsToolbar--threeAcross {
	grid-template-columns: repeat(3,auto);
	.StatsToolbar-stat {
		min-width: auto;
	}
	@include breakpoint(medium) {
		grid-template-columns: repeat(3,1fr);
	}
}

// Leaderboard
.LeaderBoard {
	--rankWidth: 1.25em;
	max-width: 100%;
	container-type: inline-size;
	padding-inline-start: $space-sm;
	border-inline-start: 1px solid subdueColor($color-text-muted);
	@include breakpoint(large) {
		margin-block-end: 0;
	}
	ul {
		margin: 0;
		list-style: none;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		// background: subdueColor($color-text-muted);
		// gap: 1px;
		// padding-block: 1px;
	}
	.LeaderBoard-item {
		background: $color-white;
		display: grid;
		align-items: baseline;
		gap: $space-sm;
		grid-template-columns: auto 1fr auto;
		padding-block: 0.125rem;
		@include text(3);
		.LeaderBoard-item-rank {
			color: $color-text-muted;
			text-align: end;
			min-width: var(--rankWidth, 1.5em);
		}
		.LeaderBoard-item-stat {
			display: flex;
			justify-content: flex-end;
			.StatBar {
				height: 1.25rem;
				.StatBar-number {
					top: 0.05rem;
				}
			}
		}
	}
}

// Fix split toolbar
.Toolbar--reversePrimaryDark {
	.Toolbar-group--fixedToBottom {
		background-color: $brand-color-ocean-blue-dark-1;
		@include breakpoint(medium) {
			background-color: transparent;
		}
	}
}

// Fix observation tools item button
.Observation-tools-item {
	@include interactiveColor(color, $color-link, $color-link-hover);
}

// Color media overlap for explore page
#explore-hero {
	.Media.Media--heroOverlap {
		background-color: $brand-color-ocean-blue-dark-2;
		text-shadow: 0 0 .5rem $brand-color-ocean-blue-dark-2;
		.Dropdown, .Suggest {
			text-shadow: none;
		}
		> .Media-content {
			img {
				@supports (mask-image: none) {
					mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 33%, rgba(0, 0, 0, 0.1) 95%);
				}
				@supports not (mask-image: none) {
					opacity: 0.75; // Edge/IE fallback
				}
			}
		}
	}
}

// Auto-detected message on home page
.RegionContextHelp {
	display: flex;
	column-gap: $space-rel-xs;
	@include text(2);
	.Icon {
		width: 1rem;
		height: 1rem;
		transform: translateY(10%);
	}
}
a.RegionContextHelp:not(.u-noUnderline) {
	@include interactiveColor(text-decoration-color, transparent, currentColor);
}

// Fix hollow button outlines
.Button.Button--hollow {
	@include interactiveColor(border-color, subdueColor($color-link), $color-link-hover);
}
.Button.Button--hollow.Button--reverse {
	@include interactiveColor(border-color, subdueColor($color-link-reverse, $reverse:true), $color-link-hover-reverse);
}

// Checklist share style
#share-checklist-form {
	margin: 1rem 0;
	padding:.5rem 0;
	border-top: 1px solid $color-line;
	border-bottom: 1px solid $color-line;
}

// Utilities to propose in base lichen
.u-stack-inside,
.u-stack-inside-md {
	display: flex;
	flex-direction: column;
	gap: $space-md;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include stack-md;
		}
	}
}
.u-stack-inside-lg {
	display: flex;
	flex-direction: column;
	gap: $space-lg;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include stack-lg;
		}
	}
}
.u-stack-inside-sm {
	display: flex;
	flex-direction: column;
	gap: $space-sm;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include stack-sm;
		}
	}
}
.u-stack-inside-xs {
	display: flex;
	flex-direction: column;
	gap: $space-xs;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include stack-xs;
		}
	}
}
.u-stack-inside-responsive {
	display: flex;
	flex-direction: column;
	gap: $space-sm;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include stack-sm;
		}
	}
	@include breakpoint(medium) {
		gap: $space-md;
		@supports not (gap: 1px) {
			> *:not(:last-child) {
				@include stack-md;
			}
		}
	}
}

.MediaFeed {
	@include stack-lg;
}

// utilities to propose to lichen
.u-inline-inside,
.u-inline-inside-md {
	display: inline-flex;
	flex-wrap: wrap;
	gap: $space-md;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include inline-md;
		}
	}
}
.u-inline-inside-sm {
	display: inline-flex;
	flex-wrap: wrap;
	gap: $space-sm;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include inline-sm;
		}
	}
}
.u-inline-inside-xs {
	display: inline-flex;
	flex-wrap: wrap;
	gap: $space-xs;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include inline-xs;
		}
	}
}
.u-inline-inside-responsive {
	display: inline-flex;
	flex-wrap: wrap;
	gap: $space-sm;
	@supports not (gap: 1px) {
		> *:not(:last-child) {
			@include inline-sm;
		}
	}
	@include breakpoint(medium) {
		gap: $space-md;
		@supports not (gap: 1px) {
			> *:not(:last-child) {
				@include inline-md;
			}
		}
	}
}

.u-fillAndCenter {
	flex-grow: 1;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.u-bg-sand {
	background: $brand-color-sand;
}

.u-bg-neutralLight {
	background: $brand-color-sky-blue-2;
}
.u-bg-neutralLighter {
	background: $brand-color-sky-blue-1 !important;
}

.u-bg-primaryLight {
	background: $brand-color-ocean-blue-2;
}
.u-bg-primaryLighter {
	background: $brand-color-ocean-blue-1 !important;
}

.u-viewAll {
	@include text(3);
	padding: 0.25rem 0.5rem;
	border-radius: 0.25rem;
	border: 1px solid $color-link;
	@include interactiveColor(border-color, subdueColor($color-link), hoverColor($color-link));
}
</style>
